var _path, _path2, _path3, _path4, _path5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkshops(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.3919 34.1332H12.4966V46.4773H57.3919V34.1332Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3415 34.2823C56.9663 34.2387 56.5765 34.2072 56.1771 34.1855C39.6788 33.3527 33.1496 42.6368 30.5665 50.1609C28.596 55.1987 22.9626 59.2319 12.4971 56.6319V68.8573C12.4559 68.8017 14.9761 69.7894 18.1692 69.9492C30.9152 70.5931 37.7082 65.0154 41.3322 58.9753C41.3492 58.9608 41.3661 58.9462 41.3831 58.9317C41.3855 58.9293 41.4169 58.8639 41.4678 58.7477C42.516 56.9587 43.6781 53.9737 44.1211 52.8771C45.7455 48.8681 50.1345 45.8638 57.3415 46.44V34.2774V34.2823Z",
    fill: "#67EEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3415 45.7177C56.9663 45.7613 56.5765 45.7928 56.1771 45.8145C39.6788 46.6473 33.1496 37.3632 30.5665 29.8391C28.596 24.8013 22.9626 20.7681 12.4971 23.3681V11.1427C12.4559 11.1983 14.9761 10.2106 18.1692 10.0508C30.9152 9.40689 37.7082 14.9846 41.3322 21.0247C41.3492 21.0392 41.3661 21.0538 41.3831 21.0683C41.3855 21.0707 41.4169 21.1361 41.4678 21.2523C42.516 23.0413 43.6781 26.0263 44.1211 27.1229C45.7455 31.1319 50.1345 34.1362 57.3415 33.56V45.7226V45.7177Z",
    fill: "#00C5ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3727 52.3073L57.3315 26.6436L69.3996 39.6606L57.3751 52.3049L57.3727 52.3073Z",
    fill: "#FFC508"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2091_14433",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 34,
    width: 46,
    height: 36
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3415 34.2823C56.9663 34.2387 56.5765 34.2072 56.1771 34.1855C39.6788 33.3527 33.1496 42.6368 30.5665 50.1609C28.5959 55.1987 22.9626 59.2319 12.4971 56.6319V68.8573C12.4559 68.8017 14.9761 69.7894 18.1692 69.9492C30.9152 70.5931 37.7082 65.0154 41.3322 58.9753C41.3492 58.9608 41.3661 58.9462 41.3831 58.9317C41.3855 58.9293 41.4169 58.8639 41.4678 58.7477C42.516 56.9587 43.678 53.9737 44.1211 52.8771C45.7455 48.8681 50.1345 45.8638 57.3415 46.44V34.2774V34.2823Z",
    fill: "#192223"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2091_14433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3415 45.7178C56.9663 45.7614 56.5765 45.7929 56.1771 45.8147C39.6788 46.6475 33.1496 37.3634 30.5665 29.8393C28.5959 24.8014 22.9626 20.7682 12.4971 23.3682V11.1428C12.4559 11.1985 14.9761 10.2107 18.1692 10.051C30.9152 9.40701 37.7082 14.9847 41.3322 21.0248C41.3492 21.0394 41.3661 21.0539 41.3831 21.0684C41.3855 21.0708 41.4169 21.1362 41.4678 21.2524C42.516 23.0414 43.678 26.0264 44.1211 27.123C45.7455 31.132 50.1345 34.1363 57.3415 33.5602V45.7227V45.7178Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshops);
export default __webpack_public_path__ + "static/media/workshops.1b35d30aabb1c030b7f346bfc5961624.svg";
export { ForwardRef as ReactComponent };